// @greenlight-spec: 28-it-dashboard-ui.md
// @greenlight-spec: 19-design-system.md
import * as React from 'react';

import { MonogramTile } from '@/components/greenlight/MonogramTile';
import { initials } from '@/lib/hueFor';
import { cn } from '@/lib/utils';

export interface UserAvatarProps {
  name: string;
  size?: number;
  deactivated?: boolean;
  className?: string;
}

/**
 * Decorative user avatar rendered as a MonogramTile circle.
 * aria-hidden because the name is provided by the surrounding row's aria-label.
 */
export function UserAvatar({
  name,
  size = 42,
  deactivated = false,
  className,
}: UserAvatarProps): React.JSX.Element {
  return (
    <MonogramTile
      seed={name}
      label={initials(name)}
      size={size}
      shape="circle"
      muted={deactivated}
      aria-hidden
      className={cn('shrink-0', className)}
    />
  );
}
